const colors = {
  primary: "#266A69",
  secondary: "rgb(244,123,56)",
  disabled: "#A0BABA",
  white: "#FFFFFF",
  gray: "#b7b8bf"
};

export default colors;
